import React from 'react';
import { X } from 'lucide-react';
import { useModalStore } from '@/hooks/useModalStore';
import MediaViewerModal from '../modal/MediaViewerModal';

const MediaGrid = ({ media, onRemove, remove = true, loading = false }) => {
  const openModal = useModalStore(s => s.openModal);

  return (
    <div className="flex flex-wrap gap-2">
      {media?.map((m, idx) => (
        <div key={idx} className="relative h-[72px] w-[72px] overflow-hidden rounded-xl">
          {m.type === 'image' || m.mime_type === 'image' ? (
            <img
              src={m.preview || m.public_url}
              className="h-full w-full object-cover"
              alt={m?.bucket || 'media-image'}
              onClick={() => {
                openModal(MediaViewerModal, {
                  src: m.preview || m.public_url,
                  type: 'image',
                });
              }}
            />
          ) : m.type === 'video' || m.mime_type === 'video' ? (
            <video
              src={m.preview || m.public_url}
              onClick={() => {
                openModal(MediaViewerModal, {
                  src: m.preview || m.public_url,
                  type: 'video',
                });
              }}
              className="h-full w-full object-cover"
              muted
              playsInline
            />
          ) : null}

          {remove && (
            <button
              type="button"
              onClick={() => onRemove(m.id || m._tempId)}
              className="absolute right-1 top-1 rounded-full bg-white/80 p-0.5"
              disabled={loading}
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default MediaGrid;
